// This function is used for making bold drug names that received from
// server as Warning Text in DIT Item, and written in all capital letters
import React from "react";
import PropTypes from "prop-types";

const excludedWordsMap = {
  INR: true,
  FDA: true,
  NOT: true,
};

const isAbbr = (word) => /^[A-Z][A-Z]$/.test(word.slice(0, 2));

const InteractionWarningLabel = ({ content }) => {
  return (
    <>
      {content.split(" ").map((word, i) => (
        <React.Fragment key={i}>
          {isAbbr(word) && !excludedWordsMap[word] ? (
            <strong>{word}</strong>
          ) : (
            word
          )}{" "}
        </React.Fragment>
      ))}
    </>
  );
};

InteractionWarningLabel.propTypes = {
  content: PropTypes.string.isRequired,
};

export default InteractionWarningLabel;
